<script lang="ts">
  import type { NodeId } from '$lib/core/model';
  import type { EditorState } from '../editor-state.svelte';
  import PropertiesPanel from './PropertiesPanel.svelte';

  const { editor, onShowSource }: { editor: EditorState; onShowSource: (id: NodeId) => void } =
    $props();

  // Escape and a click on empty canvas clear both, which is what dismisses the card.
  const shown = $derived(
    editor.activeToolId === 'measure'
      ? editor.toolMeasurements.length > 0
      : editor.selection.length > 0,
  );
</script>

{#if shown}
  <section class="card" aria-labelledby="properties-label">
    <h2 id="properties-label" class="label">Properties</h2>
    <PropertiesPanel {editor} {onShowSource} />
  </section>
{/if}

<style>
  /* An overlay, so showing it never resizes the canvas under the pointer. */
  .card {
    position: absolute;
    top: var(--space-3);
    right: var(--space-3);
    box-sizing: border-box;
    width: 17rem;
    max-width: calc(100% - 2 * var(--space-3));
    max-height: calc(100% - 2 * var(--space-3));
    overflow-y: auto;
    padding: var(--space-2) var(--space-3) var(--space-3);
    border: 1px solid var(--color-border);
    border-radius: var(--radius);
    background: color-mix(in srgb, var(--color-surface) 95%, transparent);
    box-shadow: 0 2px 8px rgb(0 0 0 / 10%);
  }

  h2 {
    margin: 0 0 var(--space-2);
    color: var(--color-text-muted);
    font: inherit;
  }

  .label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
</style>
